export function removeSelectedLocalStorageKeys(keys: string[] = []) {
    // Validate keys
    if (!Array.isArray(keys) || keys.length === 0) {
        return;
    }

    keys.filter((key) => typeof key === 'string' && key?.trim() !== '').forEach((key) => {
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }
    });
}

export function removeLocalStorageExceptKeys(keys: string[] = []) {
    const keysToKeep = new Set(keys);

    Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.has(key)) {
            localStorage.removeItem(key);
        }
    });
}
